import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { CaptchaSiteConfig } from '../types'

const captchaSiteConfig: SiteConfigFn<CaptchaSiteConfig> = ({ api }) => {
	const shouldLoadSiteFeature = api.features.isActive('platform') || api.features.isActive('siteMembers')

	return {
		shouldLoadSiteFeature,
		shouldLoadSiteConfig: false,
		siteConfig: {} as CaptchaSiteConfig,
	}
}

const name = 'captcha'

export const config = { site: captchaSiteConfig, name }
